import Decimal from 'decimal.js';

/**
 * One shared Decimal configuration for the whole app.
 *
 * 34 significant digits is the IEEE 754 decimal128 precision — far beyond any
 * realistic portfolio value, so intermediate FX and share-count maths never
 * loses cents. Rounding is half-up because that is what every statement,
 * broker and tax authority in scope uses.
 */
Decimal.set({
  precision: 34,
  rounding: Decimal.ROUND_HALF_UP,
  toExpNeg: -9e15,
  toExpPos: 9e15,
});

export { Decimal };
export type DecimalValue = Decimal;

/** Accepted inputs anywhere a decimal is expected. `number` is deliberately excluded. */
export type DecimalInput = string | Decimal;

export function toDecimal(value: DecimalInput): Decimal {
  return value instanceof Decimal ? value : new Decimal(value);
}

export const ZERO: Decimal = new Decimal(0);
